// extracted by mini-css-extract-plugin
export default {"imageContainer":"root_web-push-accept-modal-module__imageContainer___lQxNd","buttonsContainer":"root_web-push-accept-modal-module__buttonsContainer___DyR7F"};